import { useClient } from "@/clients/AxiosClient"

import { Routes } from "@/utils/enum"

export const updatePdf = async (
	noteNum: string,
	purchaseOrder: string | undefined,
	codRev: string,
	base: string,
	file: File[]
) => {
	try {
		if (!purchaseOrder) return

		const pdf = new FormData()
		pdf.append("invoiceNumber", noteNum)
		pdf.append("purchaseOrderNumber", purchaseOrder)
		pdf.append("resellerCode", codRev)
		pdf.append("base", base)

		const removeAccent = /[\u0300-\u036f]/g
		const removeSpecialCharacters = /[^a-zA-Z0-9]/g

		const fileName = file[0].name
			.normalize("NFD")
			.replace(removeAccent, "")
			.replace(removeSpecialCharacters, "")
			.replace("pdf", ".pdf")

		file.forEach((file) => {
			pdf.append("file", file, fileName)
		})

		const response = await useClient().post(
			Routes.UPDATE_COMMISSION_INVOICE,
			pdf
		)

		return response
	} catch (error) {
		return error
	}
}
